import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import HuboRoomconfig from '@/types/table/huboRoomconfig';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface HuboRoomconfigData extends HuboRoomconfig {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class HuboRoomconfigController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<HuboRoomconfigData>>(API_CONTEXT + '/app/huboRoomconfig/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<HuboRoomconfigData>(API_CONTEXT + '/app/huboRoomconfig/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/huboRoomconfig/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/huboRoomconfig/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/huboRoomconfig/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/huboRoomconfig/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/huboRoomconfig/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/huboRoomconfig/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/huboRoomconfig/deleteBatch', params, httpOptions);
  }
}
